let usageHandler = null;

export function registerTrackingUsageHandler(handler) {
  usageHandler = typeof handler === 'function' ? handler : null;
  return () => {
    if (usageHandler === handler) usageHandler = null;
  };
}

export function submitTrackingUsage(input) {
  if (!usageHandler) throw new Error('The deployment tracker is not ready to record supply usage yet.');
  return usageHandler(input);
}
